// exports.API_URL = "http://localhost:4444/api/v1";
// exports.API_URL = "https://stagingapi.goodsupermarket.edkamm.com/api/v1";
exports.API_URL = "https://api.goodsupermarket.edkamm.com/api/v1";
